/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon24Regular = forwardRef('BuildingHomeIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.348 4.837a3.75 3.75 0 0 1 5.304 0l7.318 7.318a.75.75 0 1 0 1.06-1.06l-7.318-7.318a5.25 5.25 0 0 0-7.424 0L.97 11.095a.75.75 0 1 0 1.06 1.06l7.318-7.318Z" }),
        React.createElement("path", { d: "M5.75 13a.75.75 0 0 0-1.5 0v5A3.75 3.75 0 0 0 8 21.75h8A3.75 3.75 0 0 0 19.75 18v-5a.75.75 0 0 0-1.5 0v5A2.25 2.25 0 0 1 16 20.25H8A2.25 2.25 0 0 1 5.75 18v-5Z" })));
});
